import React from 'react'
import * as T from '../../../components/Table'
import { Text, Tooltip } from '@chakra-ui/react'
import { ModalParcelas } from './ModalParcelas'
import { formatPrice } from '../../../utils/formatPrice'

export const RelatorioItem = ({ item }) => {
  return (
    <T.Tr>
      <T.Td>{item.data_pedido_liberado}</T.Td>
      <T.Td>{item.data_nfe}</T.Td>
      <T.Td>
        <Text as="a" href={item.link_pedido} color="blue.500" _hover={{ textDecoration: 'underline' }} target="_blank" rel="noreferrer">
          {item.numero_pedido}
        </Text>
      </T.Td>
      <T.Td>{item.nome_empresa}</T.Td>
      <T.Td>
        <Tooltip label={item.cliente} aria-label="A tooltip" bg="gray.300" color="black" placement="top">
          <Text isTruncated w="150px">
            {item.cliente}
          </Text>
        </Tooltip>
      </T.Td>
      <T.Td>
        <Text as="a" href={item.link_nota} color="blue.500" _hover={{ textDecoration: 'underline' }} target="_blank" rel="noreferrer">
          {item.nfe}
        </Text>
      </T.Td>
      <T.Td>R$ {item.valor_nota}</T.Td>
      <T.Td>{item.pagamento}</T.Td>
      <T.Td>{item.dados_parcelas ? <ModalParcelas parcelas={item.parcelas} item={item.dados_parcelas} /> : item.parcelas}</T.Td>
      <T.Td>R$ {item.valor_parcela}</T.Td>
      <T.Td>{item.data_vencimento}</T.Td>
      <T.Td>{item.data_pagamento}</T.Td>
      <T.Td>{formatPrice(item.valor_real)}</T.Td>
    </T.Tr>
  )
}
